import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../rootReducer';
import ScriptProjections from './drawers/ScriptProjections';
import ScriptVariables from './drawers/ScriptVariables';
import { nextTime, previousTime } from './scriptSlice';
import Time from '../graph/drawer-views/time/Time';

const mapState = (state: RootState) => ({
    currentInstance: state.scriptSlice.currentInstance,
    loop: state.scriptSlice.loop,
    numInstances: state.scriptSlice.instance.length,
    view: state.sterlingSlice.scriptView
});

const mapDispatch = {
    nextTime,
    previousTime
};

const connector = connect(mapState, mapDispatch);

type ScriptDrawerProps = ConnectedProps<typeof connector>;

const ScriptDrawer: React.FunctionComponent<ScriptDrawerProps> = props => {

    const {
        currentInstance,
        loop,
        numInstances,
        nextTime,
        previousTime
    } = props;

    return <>
        {
            numInstances > 1 && <Time
                current={currentInstance}
                loop={loop}
                nextTime={nextTime}
                previousTime={previousTime}/>
        }
        {
            props.view === 'projections' ? <ScriptProjections/>
                : props.view === 'variables' ? <ScriptVariables/>
                : null
        }
    </>

};

export default connector(ScriptDrawer);
